import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse, StateSeoContent } from '../types';

const URL = '/v2/state-seo-pages';

class StateSeoContentService {
  static get(id: number, config?: AxiosRequestConfig): Promise<DataResponse<StateSeoContent>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(params: string, config?: AxiosRequestConfig): Promise<PagedResponse<StateSeoContent>> {
    return axios.get(`${URL}${params}`, config);
  }

  static patch(id: number, data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<StateSeoContent>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static create(data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<StateSeoContent>> {
    return axios.post(`${URL}`, data, config);
  }
}

export { StateSeoContentService };
